import { parse, parseISO } from "date-fns";

export const toDate = (date: string | null | Date) =>
  typeof date === "string" ? parseISO(date) : date || new Date();

export const parseSubmitDate = (date: string) =>
  parse(date, "MMM. d, yyyy, hh:mm aaaa", new Date());
